export const prepareDamagesDescription = (damages) => {
  if (!damages) {
    return null;
  }
  if (damages.length === 1) {
    return 'damage';
  }
  return 'damages';
};
